/**
 * @generated SignedSource<<49094f97146bc9a0218a5d1ed310e285>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentMethodSelectedCustomerRegister_charge$data = {
  readonly customerRegisterFields: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkActiveCashbackFidelityBalance_charge" | "PaymentLinkActiveEarnCashbackFidelity_charge" | "PaymentLinkActiveEarnCashback_charge" | "PaymentLinkAdditionalInfo_charge" | "PaymentLinkComment_charge" | "PaymentMethodPaymentDeadline_charge" | "PaymentMethodSelectedCustomerRegisterFormFields_charge" | "PaymentMethodSelectedCustomerRegisterForm_charge" | "PaymentMethodSelectedCustomerRegisterValue_charge" | "PaymentMethodTransactionDetails_charge">;
  readonly " $fragmentType": "PaymentMethodSelectedCustomerRegister_charge";
};
export type PaymentMethodSelectedCustomerRegister_charge$key = {
  readonly " $data"?: PaymentMethodSelectedCustomerRegister_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentMethodSelectedCustomerRegister_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentMethodSelectedCustomerRegister_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customerRegisterFields",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkAdditionalInfo_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkComment_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodPaymentDeadline_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodTransactionDetails_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveEarnCashback_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveCashbackFidelityBalance_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveEarnCashbackFidelity_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodSelectedCustomerRegisterValue_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodSelectedCustomerRegisterForm_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentMethodSelectedCustomerRegisterFormFields_charge"
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "25e3f7b4208b416083b30528595a6bcc";

export default node;
